import { useEffect, useRef, useState } from "react";
import api from "@/utils/api";

const hasText = (html) => html.replace(/<[^>]+>|&nbsp;|\s/g, "").length > 0;

// Debounced server render of the finished branded email (same code path as the real send).
export const useEmailPreview = (content, groupId = "", design = null) => {
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const timer = useRef(null);
  const key = JSON.stringify({ ...content, groupId, design });
  useEffect(() => {
    const c = JSON.parse(key);
    if (!c.subject.trim() && !hasText(c.body_html)) { setPreview(null); return undefined; }
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      setLoading(true);
      api.post("/lms/admin/email-templates/preview", { ...c, subject: c.subject.trim() || "(no subject)", body_html: c.body_html || "<p></p>", group_id: c.groupId, design: c.design || undefined })
        .then(({ data }) => setPreview(data)).catch(() => {}).finally(() => setLoading(false));
    }, 450);
    return () => clearTimeout(timer.current);
  }, [key]);
  return [preview, loading];
};

export { hasText };
